import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import DetailPage from '@shell/components/Resource/Detail/Page.vue';
import { MANAGEMENT, SECRET } from '@shell/config/types';
import ResourceTabs from '@shell/components/form/ResourceTabs/index.vue';
import SecretDataTab from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/index.vue';
import KnownHostsTab from '@shell/components/Resource/Detail/ResourceTabs/KnownHostsTab/index.vue';
import { useGetKnownHostsTabProps } from '@shell/components/Resource/Detail/ResourceTabs/KnownHostsTab/composables';
import { useSecretDataTabDefaultProps } from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/composeables';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Masthead from '@shell/components/Resource/Detail/Masthead/index.vue';
import { useDefaultMastheadProps } from '@shell/components/Resource/Detail/Masthead/composable';

export interface Props {
  value: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'secret',
  props: {
    value: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;
const schema = computed(() => store.getters['cluster/schemaFor'](SECRET));
const secret = props.value;

if (secret.isProjectScoped) {
  store.dispatch('management/find', { id: secret.projectId, type: MANAGEMENT.PROJECT });
}

const defaultMastheadProps = useDefaultMastheadProps(secret);
const knownHostsTabProps = useGetKnownHostsTabProps(secret);
const secretDataTabProps = useSecretDataTabDefaultProps(secret);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DetailPage, null, {
    "top-area": _withCtx(() => [
      _createVNode(Masthead, _normalizeProps(_guardReactiveProps(_unref(defaultMastheadProps))), null, 16)
    ]),
    "bottom-area": _withCtx(() => [
      _createVNode(ResourceTabs, {
        value: _unref(secret),
        schema: schema.value
      }, {
        default: _withCtx(() => [
          _createVNode(SecretDataTab, _mergeProps(_unref(secretDataTabProps), { weight: 1 }), null, 16),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (_unref(knownHostsTabProps))
            ? (_openBlock(), _createBlock(KnownHostsTab, _mergeProps({ key: 0 }, _unref(knownHostsTabProps), { weight: 0 }), null, 16))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "schema"])
    ]),
    _: 1
  }))
}
}

})